import styled from '@emotion/styled';
import { Flex, Modal, Button } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledFlexWelcomeText = styled(Flex)`
  width: 456px;
  @media (max-width: 1023px) {
    height: auto;
  }
`;
export const StyledWelcomeLeftImage = styled(Flex)`
  width: 310px;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const StyledWelcomeImage = styled.img`
  padding: 24px 0;
`;
export const StyledWelcomeHeaderText = styled.div`
  font-family: 'Work Sans', sans-serif;
  font-size: 34px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 21px;
  margin-top: 30px;
  margin-left: 10px;
`;

export const StyledWelcomeTextP = styled.div`
  font-family: 'Work Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-left: 10px;
  margin-right: 60px;
`;

export const StyledWelcomeTextPSub = styled.div`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  padding-right: 40px;
`;
export const StyledWelcomeTextL = styled.div`
  font-family: 'Work Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  line-height: 1.88;
  margin-left: 10px;
  text-decoration: none !important;
`;

export const StyledWelcomeTextButton = styled(Button)`
  text-decoration: none;
  color: ${COLORS.seaBlue}!important;
  cursor: pointer !important;
  font-weight: bold !important;
  font-size: 16px !important;
  padding: 0 !important;
  height: 25px !important;
  background: transparent !important;
  margin: 0 !important;
  border-color: transparent;
  text-transform: inherit;
  &:hover {
    background: transparent !important;
    color: ${COLORS.seaBlue}!important;
    border-color: transparent;
  }
  &:active {
    background: transparent !important;
    color: ${COLORS.seaBlue}!important;
    border-color: transparent;
  }
  &:focus {
    background: transparent !important;
    color: ${COLORS.seaBlue}!important;
    border-color: transparent;
    outline: none !important;
  }
`;

export const StyledModal = styled(Modal)`
  height: auto;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  vertical-align: middle;
  align-content: center;
  margin: 0 auto !important;
  @media (max-width: 1023px) {
    height: auto;
  }
  @media (max-width: 767px) {
    width: 100% !important;
    max-width: 600px !important;
  }
`;

export const StyledButton = styled(Button)`
  margin-left: 10px;
  border-radius: 8px;
`;
